import { useState, useEffect } from "react"
import Badge from 'react-bootstrap/Badge';
import { fmtMes } from "../components/generalFunctions";
import ModalEmissao from "../modals/ModalEmissao"
import moment from 'moment'
import { Link } from 'react-router-dom'
import { MaterialReactTable, MRT_ColumnDef } from 'material-react-table';
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR';
import LoaderIcon from 'react-loading-icons'
import api from "../components/api";
import toast from "react-hot-toast";
import { useQuery } from "@tanstack/react-query";




interface iFavorecidos {

    favorecido_id: number,
    tipoJuridico: string,
    nome: string,
    cnpj: string,
    cpf: string,
    nomeFantasia: string,
    razaoSocial: string,

}

interface iTomadores {

    tomador_id: number,
    nomeFantasia: string,
    razaoSocial: string,
    tipoJuridico: string,
    nome: string,
    cnpj: string,
    cpf: string,
    outroDocumento: string,

}

interface iDados {

    pin: string,
    emissao_id: number,
    dataEmissao: string,
    dataVencimento: string,
    favorecidos: iFavorecidos[],
    valor: string,
    modalidadeDescricao: string,
    tomadores: iTomadores[],
    statusEmissao: string,



}

interface iClientes {

    cliente_id: number,
    nomeFantasia: string,
    razaoSocial: string,
    cnpj: string,


}


interface iFavorecido {

    favorecido_id: number,
    cnpj: string,
    cpf: string,
    nome: string,
    nomeFantasia: string,
    razaoSocial: string,
    tipoJuridico: string,
    outroDocumento: string,
    favorecido: string,

}

interface iPin {

    emissao_id: number,
    pin: string,
    valor: number,

}


export default function EmissoesLista(props: any) {

    const { origem, dias, cliente_id: cliente_id_props } = props


    const [show, setShow] = useState<boolean>(false)
    const [now, setNow] = useState<string | undefined>('')
    const [pin, setPin] = useState<string | undefined>(undefined)
    const [ano, setAno] = useState<string | undefined>(String(moment().year()))
    const [listaAnos, setListaAnos] = useState<number[]>([]);

    const [resultadoTomador, setResultadoTomador] = useState<React.ReactNode>()
    const [tomador_id, setTomador_id] = useState<number | undefined>()
    const [tomador, setTomador] = useState<string | undefined>('')

    const [resultadoFavorecido, setResultadoFavorecido] = useState<React.ReactNode>()
    const [favorecido_id, setFavorecido_id] = useState<number | undefined>()
    const [favorecido, setFavorecido] = useState<string | undefined>('')


    const [resultadoPin, setResultadoPin] = useState<React.ReactNode>()
    const [pin2, setPin2] = useState<string | undefined>(undefined)
    const [buscaPin, setBuscaPin] = useState<string | undefined>('')

    const [statusEmissao, setStatusEmissao] = useState<string>('')

    const [mes, setMes] = useState<string | undefined>()
    const [listaMeses, setListaMeses] = useState<number[]>([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]);



    var anoAtual = moment().format('YYYY')


    //const [resultado, setResultado] = useState<iDados[]>([])
    const [carregando, setCarregando] = useState<string>('none')

    const [cliente_id, setCliente_id] = useState<number | undefined>()
    const [clientes, setClientes] = useState<[]>([])
    const [emissao_id, setEmissao_id] = useState<number | undefined>()

    const dadosUsuarios = sessionStorage.getItem('dadosUsuarios')

    useEffect(() => {

        if (dadosUsuarios) {

            var dados = JSON.parse(dadosUsuarios)

            setClientes(dados.clientes)
            //setCliente_id(dados.clientes.length == 1 ? dados.clientes[0].cliente_id : undefined)
            setCliente_id(dados.clientes.length == 1 ? dados.clientes[0].cliente_id : localStorage.getItem('cliente_id') ? Number(localStorage.getItem('cliente_id')) : undefined)
            //setCliente_id(dados.cliente_id ? Number(dados.cliente_id) : undefined)


        }

    }, [dadosUsuarios])


    useEffect(() => {

        if (cliente_id_props) {

            setCliente_id(cliente_id_props)

        }

    }, [cliente_id_props])

    function carregaAnos() {

        const x_array: number[] = [];

        for (let x = 2022; x <= parseInt(anoAtual); x++) {
            x_array.push(x);
        }

        setListaAnos(x_array.sort().reverse());
    }


    useEffect(() => {
        carregaAnos()
    }, [])




    useEffect(() => {

        if (cliente_id) {

            localStorage.setItem('cliente_id', String(cliente_id))

        }

    }, [cliente_id])


    /*

    const carregaEmissoes = () => {


        setCarregando('block')

        var dataPost = {

            ano: ano,

        }

        api.post(`emissaoListaTodos/${cliente_id}`, dataPost).then((result) => {

            //console.log(result.data)

            setResultado(result.data)
            setCarregando('none')

        }).catch((err) => {

            console.log(err.response)
            setCarregando('none')

        })

    }



    useEffect(() => {

        if (cliente_id) {

            carregaEmissoes()

        }

    }, [ano, mes, cliente_id])

    */


    const { data: resultado, isLoading, refetch } = useQuery({


        queryKey: ['emissoes', ano, mes, cliente_id, tomador_id, favorecido_id, pin2, statusEmissao, dias],
        queryFn: async () => {

            try {

                if (pin2 || dias) { 
                    
                    setAno('')
                    setMes('') 
                
                }

                

                var dataPost = {

                    ano: ano != undefined && ano != '' && !pin2 && !dias ? ano : null,
                    mes: mes != undefined && mes != '' && !pin2 ? !dias && mes : null,
                    tomador_id: tomador_id != undefined ? tomador_id : null,
                    favorecido_id: favorecido_id != undefined ? favorecido_id : null,
                    pin: pin2 != undefined ? pin2 : null,
                    statusEmissao: statusEmissao != '' ? statusEmissao : null,
                    garantiaAVencer: dias,

                }

                //console.log(dataPost)

                const result = await api.post<iDados[]>(`emissaoListaTodos/${cliente_id}`, dataPost)
                //console.log(result.data)
                return result.data ?? []

            } catch (err: any) {

                console.log(err.response)
                throw err

            }

        },
        enabled: !!cliente_id


    })


    const getBadgeVariant = (status: string) => {

        switch (status) {

            case 'Garantia':
                return 'success'
          
            case 'Minuta':
                return 'secondary'
          
            default:
                return 'warning'  
        }
      }


    const columns: MRT_ColumnDef<iDados>[] = [

        {
            accessorKey: 'pin',
            header: 'Pin',
            Cell: ({ renderedCellValue, row }) => (

                <Badge style={{ fontSize: '0.7rem' }} bg='warning'>{renderedCellValue}</Badge>

            ),

        },

        {
            accessorKey: 'statusEmissao',
            header: 'Situação',
            Cell: ({ row }) => {
                const status = row.original.statusEmissao
              
                return (
                  <Badge
                    style={{ fontSize: '0.7rem' }}
                    bg={getBadgeVariant(status)}
                  >
                    {status}
                  </Badge>
                )
              },
          },


        {
            accessorKey: 'dataEmissao',
            header: 'Emissão',
            accessorFn: (row) => {
                const raw = row.dataEmissao;
                if (!raw) return null;

                return moment(raw, 'DD/MM/YYYY').toDate();
            },
            Cell: ({ cell }) => {
                const date = cell.getValue();

                if (!date) return '-';

                return moment(date).format('DD/MM/YYYY');
            },
            sortingFn: 'datetime',
            muiTableHeadCellProps: {
                align: 'center',
            },
            muiTableBodyCellProps: {
                align: 'center',
            },
        },

        {
            accessorKey: 'dataVencimento',
            header: 'Vencimento',

            Cell: ({ cell }) => {
                const raw = cell.getValue() as string;

                if (!raw || typeof raw !== 'string') return '-';

                const parsed = moment(raw, 'DD/MM/YYYY', true); // strict parse

                if (!parsed.isValid()) return '-';

                return parsed.format('DD/MM/YYYY');
            },

            sortingFn: (rowA, rowB, columnId) => {
                const a = moment(rowA.getValue(columnId), 'DD/MM/YYYY', true);
                const b = moment(rowB.getValue(columnId), 'DD/MM/YYYY', true);

                if (!a.isValid() && !b.isValid()) return 0;
                if (!a.isValid()) return 1;
                if (!b.isValid()) return -1;

                return a.toDate().getTime() - b.toDate().getTime();
            },

            muiTableHeadCellProps: {
                align: 'center',
            },
            muiTableBodyCellProps: {
                align: 'center',
            },
        },



        {
            accessorKey: 'valor',
            header: 'Valor',
            muiTableHeadCellProps: {
                align: 'right',
            },
            muiTableBodyCellProps: {
                align: 'right',
            },


        },
        {
            accessorKey: 'modalidadeDescricao',
            header: 'Modalidade',


        },
        {
            accessorKey: 'tomadores',
            header: 'Tomadores',
            Cell: ({ row }) => {
                const tomadores = row.original.tomadores;


                return tomadores && tomadores.length > 0 ? (
                    <ul style={{ paddingLeft: '1rem', margin: 0 }}>
                        {tomadores.map((rs: iTomadores) =>

                            <li>{rs.tipoJuridico == 'F' ? rs.nome : rs.tipoJuridico == 'O' ? rs.nome : rs.razaoSocial}</li>

                        )}
                    </ul>
                ) : (
                    <span>-</span>
                );
            },
        },
        {
            accessorKey: 'favorecidos',
            header: 'Favorecidos',
            Cell: ({ row }) => {
                const favorecidos = row.original.favorecidos;


                return favorecidos && favorecidos.length > 0 ? (
                    <ul style={{ paddingLeft: '1rem', margin: 0 }}>
                        {favorecidos.map((rs: iFavorecidos) =>

                            <li>{rs.tipoJuridico == 'F' ? rs.nome : rs.tipoJuridico == 'O' ? rs.nome : rs.razaoSocial}</li>

                        )}
                    </ul>
                ) : (
                    <span>-</span>
                );
            },
        },





    ]



    useEffect(() => {

        if (tomador != '' && !tomador_id) {

            var dataPost = {

                tomador: tomador,
                cliente_id: cliente_id,

            }

            api.post('buscaTomador', dataPost).then((result) => {

                //console.log(result.data)

                setResultadoTomador(result.data.map((rs: iTomadores) =>

                    <Link to='#' onClick={() => {setTomador_id(rs.tomador_id);setResultadoTomador('');setTomador(`${rs.tipoJuridico == 'J' ? rs.razaoSocial : rs.nome}`)}}><span style={{ color: 'purple' }}>[{rs.tipoJuridico == 'J' ? rs.cnpj : rs.tipoJuridico == 'F' ? rs.cpf : rs.outroDocumento}]</span> - {rs.tipoJuridico == 'J' ? rs.razaoSocial :  rs.nome}&nbsp;</Link>

                ))

            }).catch((err) => {

                console.log(err.response)

            })

        }

    }, [tomador])




    useEffect(() => {

        if (favorecido != '' && !favorecido_id) {

            var dataPost = {

                descricao: favorecido,
                cliente_id: cliente_id,

            }

            api.post('favorecidoBusca', dataPost).then((result) => {

                setResultadoFavorecido(result.data.map((rs: iFavorecido) =>

                    <Link to='#' onClick={() => {setFavorecido_id(rs.favorecido_id);setResultadoFavorecido('');setFavorecido(`${rs.tipoJuridico == 'J' ? rs.razaoSocial : rs.nome}`)}}><span style={{ color: 'purple' }}>[{rs.tipoJuridico == 'J' ? rs.cnpj : rs.tipoJuridico == 'F' ? rs.cpf : rs.outroDocumento}]</span> - {rs.tipoJuridico == 'J' ? rs.razaoSocial :  rs.nome }&nbsp;</Link>


                ))

            }).catch((err) => {

                console.log(err.response)

            })

        }

    }, [favorecido])



    useEffect(() => {

        if (buscaPin != '' && !pin2) {

            var dataPost = {

                pin: buscaPin,
                cliente_id,

            }

            //console.log(dataPost)

            api.post('buscaPin', dataPost).then((result) => {
                //console.log(result.data)

                setResultadoPin(result.data.map((rs: iPin) =>

                    <Link to='#' onClick={() => {setPin2(rs.pin);setResultadoPin('');setBuscaPin(`[${rs.pin}] R$ ${rs.valor.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2})}`)}}><span style={{ color: 'purple' }}>[{rs.pin}]</span> R$ {rs.valor.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2})}&nbsp;</Link>


                ))

            }).catch((err) => {

                console.log(err.response)

            })

        }

    }, [buscaPin])




    const exportaExcel = async () => {

        
        
        var dataPost = {

            ano: ano != undefined && ano != '' && !pin2 ? ano : null,
            mes: mes != undefined && mes != '' && !pin2 ? mes : null,
            tomador_id: tomador_id != undefined ? tomador_id : null,
            favorecido_id: favorecido_id != undefined ? favorecido_id : null,
            pin: pin2 != undefined ? pin2 : null,
            statusEmissao: statusEmissao != '' ? statusEmissao : null,
            garantiaAVencer: dias,

        }

      

        try {
            const response = await api.post<Blob>(`emissaoExcel/${cliente_id}`, dataPost, {
                responseType: "blob",
                validateStatus: (status) => true // para não cair direto no catch
            });
        
            if (response.status !== 200) {
                // ler como texto para ver o erro real
                const errorText = await response.data.text();
                console.error("Erro backend:", errorText);
                toast.error("Erro ao exportar: " + errorText);
                return;
            }
        
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `emissoes.xlsx`);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        
            toast.success("Download concluído!");
            } catch (err) {
            console.error(err);
            toast.error("Falha ao baixar arquivo");
            }


        
    }



    return (

        <div>


            <div className="col-md-12" style={{ marginBottom: 20 }}>



                <div className="d-md-flex d-grid align-items-center gap-2">

                    {

                        origem != 'emissaoAVencer' && (

                            <button type="button" className="btn btn-primary" onClick={() => {
                                setNow(moment().format('YYYY-MM-DD HH:mm:ss'));
                                setPin(undefined);
                                //setCliente_id(undefined);
                                setEmissao_id(undefined);
                                setShow(true)
                            }}>+ Novo</button>

                        )

                    }


                    <button type="button" className="btn btn-success" onClick={() => exportaExcel()}>Exportar XLSX</button>

                </div>

                

            </div>



            <div className="row" >

                <div className="row g-3">
                    <div className="col-md-2">

                        <select className="form-control" value={ano} onChange={event => setAno(event.target.value)} >
                            <option value=''>[Todos os ano]</option>
                            {listaAnos.map((rs) =>

                                <option key={rs} value={rs}>{rs}</option>

                            )}
                        </select>
                    </div>
                    <div className="col-md-2">

                        <select className="form-control" value={mes} onChange={event => setMes(event.target.value)} >
                            <option value="">[Mês]</option>
                            {listaMeses.map((rs) =>

                                <option key={rs} value={rs}>{fmtMes(rs)}</option>

                            )}
                        </select>
                    </div>
                    <div className="col-md-2">

                        <select className="form-control" value={statusEmissao} onChange={event => setStatusEmissao(event.target.value)} >
                            <option value="">[Situação]</option>
                            <option value="Minuta">Minuta</option>
                            <option value="Garantia">Garantia</option>
                           
                        </select>
                    </div>
                    <div className="col-md-6">

                        <select className="form-control" value={cliente_id} disabled={clientes.length > 1 ? false : true} onChange={event => setCliente_id(event.target.value ? Number(event.target.value) : undefined)} >
                            {clientes.length > 1 && (<option value="">[Afiançadora]</option>)}

                            {

                                clientes.map((rs: iClientes) =>

                                    <option value={rs.cliente_id}>{rs.cnpj} - {rs.razaoSocial}</option>
                                )

                            }

                        </select>
                    </div>
                    <div className="col-md-4">

                        <input type="text"
                            className="form-control"
                            style={{ backgroundColor: tomador_id != undefined ? 'orange' : 'white' }}
                            value={tomador}
                            onChange={event => setTomador(event.target.value)} onFocus={() => { setTomador(''); setResultadoTomador(''); setTomador_id(undefined) }}
                            placeholder="Tomador"
                            
                        />
                        {resultadoTomador}
                    </div>

                    <div className="col-md-4">
                        
                        <input type="text" className="form-control" style={{ backgroundColor: favorecido_id != undefined ? 'orange' : 'white' }} 
                        value={favorecido} 
                        onChange={event => setFavorecido(event.target.value)} onFocus={() => { setFavorecido(''); setFavorecido_id(undefined) }} 
                        placeholder="Favorecido"
                        />
                        {resultadoFavorecido}
                    </div>

                    <div className="col-md-4">
                        
                        <input type="text" className="form-control" style={{ backgroundColor: pin2 != undefined && pin2 != '' ? 'orange' : 'white' }} 
                        value={buscaPin} 
                        onChange={event => setBuscaPin(event.target.value)} onFocus={() => { setBuscaPin(''); setPin2(undefined) }} 
                        placeholder="PIN"
                        />
                        {resultadoPin}
                    </div>

                    <div className="col-12 col-xl-12">


                        <center>
                            <LoaderIcon.Puff stroke="#000" style={{ display: isLoading ? 'block' : 'none' }} />
                        </center>


                        <div className="col-lg-12" style={{ display: resultado && resultado?.length > 0 ? 'block' : 'none' }}>


                            <MaterialReactTable

                                columns={columns}
                                data={resultado ?? []}
                                localization={MRT_Localization_PT_BR}
                                //rowsPerPage={20}
                                //options={options}
                                initialState={{
                                    density: 'compact', sorting: [
                                        { id: 'dataEmissao', desc: true },
                                    ],
                                }}
                                muiTableHeadCellProps={{
                                    //easier way to create media queries, no useMediaQuery hook needed.
                                    sx: {
                                        fontSize: {
                                            xs: '8px',
                                            sm: '9px',
                                            md: '10px',
                                            lg: '11px',
                                            xl: '12px',
                                        },
                                    },
                                }}
                                muiTableBodyCellProps={{
                                    sx: {
                                        fontSize: {
                                            xs: '8px',
                                            sm: '9px',
                                            md: '10px',
                                            lg: '11px',
                                            xl: '12px',
                                        },
                                    },
                                }}
                                muiTableBodyRowProps={({ row }) => ({
                                    onClick: () => {
                                        setShow(true);
                                        setEmissao_id(row.original.emissao_id)
                                        setPin(row.original.pin)
                                        setNow(moment().format('YYYYMMDDHHmmss'))
                                    },
                                    sx: {
                                        cursor: 'pointer',
                                    },
                                })}
                            />

                        </div>



                    </div>
                </div>
            </div>

            <ModalEmissao emissao_id={emissao_id} setEmissao_id={setEmissao_id} setPin={setPin} pin={pin} cliente_id={cliente_id} show={show} setShow={setShow} now={now} setNow={setNow} carregaEmissoes={refetch} />

        </div>

    )


}

